import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-lists',
    templateUrl: './lists.component.html',
    styleUrls: ['./lists.component.css'],
    standalone: false
})
export class ListsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
